module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.properties.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("\n        No results\n    ")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, _vm._l((_vm.properties), function(item, index) {
    return _c('v-list-group', {
      key: item.Code,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item.Code)
        }
      },
      slot: "item"
    }, [(item.Icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.Icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.Code))])], 1)], 1)], 1)
  }))], 1)], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e804391e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Properties.vue
// module id = 398
// module chunks = 0